<script>
  import {
    Breadcrumb,
    Button,
    ButtonGroup,
    Input,
    Close,
    InputAddonItem,
  } from "agnostic-svelte"
  import { navigate } from "svelte-routing"
  import svg_x from "../icons/x-lg.svg"
  import { store } from "./store"

  let routes = ["Your Info", "Savings", "Personalize"]
  let state = 0
  let next = () => {
    if (++state > 1) {
      navigate("/plans")
      // state = 0
    }
  }
  let prev = () => {
    if (--state < 0) {
      navigate("/")
    }
  }
  let userd = store.userd

  let people = userd.people

  function pnew(n) {
    people.push({ name: n })
    people = people
  }
  function pdel(n) {
    people.splice(people.indexOf(n), 1)
    people = people
  }
</script>

{#if state === 0}
  <h1>Who needs health coverage?</h1>
  <div class="flex flex-column items-center container">
    {#each people as p, i}
      <div class="round p12" style="width:100%;border:gray solid 1px">
        <h2>
          {p.name}
          <div style="float:right;">
            {#if i}<Close on:click={() => pdel(p)} />{/if}
          </div>
        </h2>
        <div class="flex flex-wrap">
          <div style="width:50%">
            <Input style="border-radius:10px" bind:value={p.age} label="Age" />
          </div>
          <div style="width:50%">
            <div>Sex</div>
            <ButtonGroup>
              <Button
                size=""
                isGrouped
                mode={p.sex === "M" ? "primary" : undefined}
                on:click={() => (p.sex = "M")}>M</Button
              >
              <Button
                isGrouped
                mode={p.sex === "F" ? "primary" : undefined}
                on:click={() => (p.sex = "F")}>F</Button
              >
            </ButtonGroup>
          </div>
        </div>
      </div>
    {/each}

    {#if !people.some((v) => v.name === "Spouse")}<Button
        on:click={() => pnew("Spouse")}>Your Spouse</Button
      >{/if}
    <Button on:click={() => pnew("Dependent")}>Your Dependent</Button>

    <ButtonGroup>
      <Button isGrouped on:click={prev}>Prev</Button>
      <Button isGrouped mode="primary" on:click={next}>Next</Button>
    </ButtonGroup>
  </div>
{:else if state === 1}
  <h1>Your household</h1>
  <div class="flex flex-column items-center container">
    <Input
      type="number"
      bind:value={userd.people_num}
      label="How many people are in your tax household?"
    />

    <Input
      type="number"
      bind:value={userd.income}
      hasLeftAddon={true}
      label="What is your household income?"
    >
      <div slot="addonLeft">
        <InputAddonItem addonLeft={true}><span>$</span></InputAddonItem>
      </div>
    </Input>
    <ButtonGroup>
      <Button isGrouped on:click={prev}>Prev</Button>
      <Button isGrouped mode="primary" on:click={next}>Next</Button>
    </ButtonGroup>
  </div>
{:else if state === 2}
  <h1>Doctors</h1>
{:else if state === 3}
  <h1>Drugs</h1>
{/if}

<!-- {#each routes as route, index}
  {` ${index === 0 ? "" : "-"} ${route}`}
{/each} -->
<style>
</style>
